import React               from 'react';
import { Link }            from 'react-router-dom';
import { getRoute }        from 'pursuit/routes/routes';
import OurTeamProfilePhoto from 'pursuit/components/Widgets/OurTeamProfilePhoto';

export default function OurTeamPreview(props) {
    const { staffer } = props;

    return (
        <article>
            <Link
                to={getRoute('ourTeamMember', {member: staffer.slug})}
                className="our-team--preview"
            >
                <OurTeamProfilePhoto
                    profile={staffer.firstName}
                    preview
                />
                <h3 className="minor-margin--bottom">
                    {staffer.fullName}
                    <div
                        className="text-small text-thin lowlight"
                        dangerouslySetInnerHTML={{__html: staffer.mainDiscipline}}
                    />
                </h3>
            </Link>
        </article>
    )
}
